<template>
	<div class="full" v-loading="loading">
		<el-container>
			<el-main>
				<div>
					<el-divider content-position="center">万里牛</el-divider>
					<el-row :gutter="20">
<!-- 						<el-col :span="6">
							<el-card>
								<el-statistic group-separator="," :precision="0" title="订单审核">
									<template slot="formatter">
										<div style="font-size: 12px;">
											<div>最近抓取日期：实时抓取</div>
											<div>动态数量：{{data.bi_audittrade?data.bi_audittrade.total:'不存在'}}</div>
											<div>未抓取明细：{{data.bi_audittrade?data.bi_audittrade.remain_detail:'不存在'}}</div>
											<div>备注：库存同步</div>
										</div>
									</template>
								</el-statistic>
							</el-card>
						</el-col> -->
						<el-col :span="6">
							<el-card>
								<el-statistic group-separator="," :precision="0" title="商品">
									<template slot="formatter">
										<div style="font-size: 12px;">
											<div>最近抓取日期：{{data.bi_goodsupdate?data.bi_goodsupdate.task_time:'不存在'}}</div>
											<div>新增/更新数量：{{data.bi_goodsupdate?data.bi_goodsupdate.datacount:0}}</div>
											<div>未抓取明细：{{data.bi_goodsupdate?data.bi_goodsupdate.remain_detail:'不存在'}}</div>
											<div>备注：商品同步</div>
										</div>
									</template>
								</el-statistic>
							</el-card>
						</el-col>
						<el-col :span="6">
							<el-card>
								<el-statistic group-separator="," :precision="0"  title="采购订单">
									<template slot="formatter">
										<div style="font-size: 12px;">
											<div>最近抓取日期：{{data.bi_purchase?data.bi_purchase.task_time:'不存在'}}</div>
											<div>未抓取明细：{{data.bi_purchase?data.bi_purchase.remain_detail:'不存在'}}</div>											
											<div>单据数量：{{data.bi_purchase?data.bi_purchase.datacount:0}} / 明细数量：{{data.bi_purchase?data.bi_purchase.detailcount:0}}</div>
											<div>备注：BI</div>
										</div>
									</template>
								</el-statistic>
							</el-card>
						</el-col>
						<el-col :span="6">
							<el-card>
								<el-statistic group-separator="," :precision="0"  title="预付款单">
									<template slot="formatter">
										<div style="font-size: 12px;">
											<div>最近抓取日期：{{data.bi_purchase_finbill?data.bi_purchase_finbill.task_time:'不存在'}}</div>
											<div>单据数量：{{data.bi_purchase_finbill?data.bi_purchase_finbill.datacount:0}}</div>
											<div>备注：BI</div>
										</div>
									</template>
								</el-statistic>
							</el-card>
						</el-col>
						<el-col :span="6">
							<el-card>
								<el-statistic group-separator="," :precision="0"  title="售后单">
									<template slot="formatter">
										<div style="font-size: 12px;">
											<div>最近抓取日期：{{data.bi_exchange?data.bi_exchange.task_time:'不存在'}}</div>
											<div>未抓取明细：{{data.bi_exchange?data.bi_exchange.remain_detail:'不存在'}}</div>
											<div>单据数量：{{data.bi_exchange?data.bi_exchange.datacount:0}} / 明细数量：{{data.bi_exchange?data.bi_trade.detailcount:0}}</div>
											
											<div>备注：BI</div>
										</div>
									</template>
								</el-statistic>
							</el-card>
						</el-col>
					</el-row>
					<el-row :gutter="20" style="margin-top: 20px;">
						<el-col :span="6">
							<el-card>
								<el-statistic group-separator="," :precision="0"  title="采购退货订单">
									<template slot="formatter">
										<div style="font-size: 12px;">
											<div>最近抓取日期：{{data.bi_purchaseback?data.bi_purchaseback.task_time:'不存在'}}</div>
											<div>未抓取明细：{{data.bi_purchaseback?data.bi_purchaseback.remain_detail:'不存在'}}</div>
											<div>单据数量：{{data.bi_purchaseback?data.bi_purchaseback.datacount:0}} / 明细数量：{{data.bi_purchaseback?data.bi_purchaseback.detailcount:0}}</div>
											
											<div>备注：BI</div>
										</div>
									</template>
								</el-statistic>
							</el-card>
						</el-col>
						<el-col :span="6">
							<el-card>
								<el-statistic group-separator="," :precision="0"  title="采购退货单">
									<template slot="formatter">
										<div style="font-size: 12px;">
											<div>最近抓取日期：{{data.bi_purchaseoutstockbill?data.bi_purchaseoutstockbill.task_time:'不存在'}}</div>
											<div>未抓取明细：{{data.bi_purchaseoutstockbill?data.bi_purchaseoutstockbill.remain_detail:'不存在'}}</div>
											<div>单据数量：{{data.bi_purchaseoutstockbill?data.bi_purchaseoutstockbill.datacount:0}} / 明细数量：{{data.bi_purchaseoutstockbill?data.bi_purchaseoutstockbill.detailcount:0}}</div>
											
											<div>备注：BI</div>
										</div>
									</template>
								</el-statistic>
							</el-card>
						</el-col>
						<el-col :span="6">
							<el-card>
								<el-statistic group-separator="," :precision="0"  title="采购入库单">
									<template slot="formatter">
										<div style="font-size: 12px;">
											<div>最近抓取日期：{{data.bi_purchasestockbill?data.bi_purchasestockbill.task_time:'不存在'}}</div>
											<div>未抓取明细：{{data.bi_purchasestockbill?data.bi_purchasestockbill.remain_detail:'不存在'}}</div>
											<div>单据数量：{{data.bi_purchasestockbill?data.bi_purchasestockbill.datacount:0}} / 明细数量：{{data.bi_purchasestockbill?data.bi_purchasestockbill.detailcount:0}}</div>
											
											<div>备注：BI</div>
										</div>
									</template>
								</el-statistic>
							</el-card>
						</el-col>
						<el-col :span="6">
							<el-card>
								<el-statistic group-separator="," :precision="0"  title="出库单">
									<template slot="formatter">
										<div style="font-size: 12px;">
											<div>最近抓取日期：{{data.bi_searchsaleinvbill?data.bi_searchsaleinvbill.task_time:'不存在'}}</div>
											<div>未抓取明细：{{data.bi_searchsaleinvbill?data.bi_searchsaleinvbill.remain_detail:'不存在'}}</div>
											<div>单据数量：{{data.bi_searchsaleinvbill?data.bi_searchsaleinvbill.datacount:0}} / 明细数量：{{data.bi_searchsaleinvbill?data.bi_searchsaleinvbill.detailcount:0}}</div>
											<div>备注：BI</div>
										</div>
									</template>
								</el-statistic>
							</el-card>
						</el-col>					
					</el-row>
					<el-row :gutter="20" style="margin-top: 20px;">
						<el-col :span="6">
							<el-card>
								<el-statistic group-separator="," :precision="0"  title="销售单">
									<template slot="formatter">
										<div style="font-size: 12px;">
											<div>最近抓取日期：{{data.bi_trade?data.bi_trade.task_time:'不存在'}}</div>
											<div>未抓取明细：{{data.bi_trade?data.bi_trade.remain_detail:'不存在'}}</div>
											<div>单据数量：{{data.bi_trade?data.bi_trade.datacount:0}} / 明细数量：{{data.bi_trade?data.bi_trade.detailcount:0}}</div>
											
											<div>备注：BI</div>
										</div>
									</template>
								</el-statistic>
							</el-card>
						</el-col>
						<el-col :span="6">
							<el-card>
								<el-statistic group-separator="," :precision="0"  title="销售单退货">
									<template slot="formatter">
										<div style="font-size: 12px;">
											<div>最近抓取日期：{{data.bi_tradeback?data.bi_tradeback.task_time:'不存在'}}</div>
											<div>未抓取明细：{{data.bi_tradeback?data.bi_tradeback.remain_detail:'不存在'}}</div>
											<div>单据数量：{{data.bi_tradeback?data.bi_tradeback.datacount:0}} / 明细数量：{{data.bi_tradeback?data.bi_tradeback.detailcount:0}}</div>
											
											<div>备注：BI</div>
										</div>
									</template>
								</el-statistic>
							</el-card>
						</el-col>

				
					</el-row>
					<el-divider content-position="center">小望</el-divider>
					<el-row :gutter="20" style="margin-top: 20px;">	
						<el-col :span="6">
							<el-card>
								<el-statistic group-separator="," :precision="0"  title="已开票订单">
									<template slot="formatter">
										<div style="font-size: 12px;">
											<div>最近抓取日期：{{data.bi_xwinvoiceorder?data.bi_xwinvoiceorder.task_time:'不存在'}}</div>						
											<div>白名单数量：{{data.bi_xwinvoiceorder?data.bi_xwinvoiceorder.datacount:0}}</div>
											<div>备注：添加开票白名单</div>
										</div>
									</template>
								</el-statistic>
							</el-card>
						</el-col>
						<el-col :span="6">
							<el-card>
								<el-statistic group-separator="," :precision="0"  title="订单待审核">
									<template slot="formatter">
										<div style="font-size: 12px;">
											<div>最近抓取日期：实时抓取</div>
											<div>抓取到第{{data.xw_auditinvoice?data.xw_auditinvoice.content.pageNo:0}}页</div>						
											<div>备注：白名单自动同意</div>
										</div>
									</template>
								</el-statistic>
							</el-card>
						</el-col>
					</el-row>
				</div>
			</el-main>
		</el-container>
	</div>
</template>
<style scoped>
	.departmen_container {
		padding: 10px;
		box-sizing: border-box;
		flex-direction: column;
	}

	.tabs {
		flex-direction: column;
		position: relative;
		width: 100%;
		height: 100%;
	}
</style>
<script>
	export default {
		name: 'grabIndex',
		props: {

		},
		data() {
			return {
				loading:false,
				// like: true,
				// value1: 4154.564,
				// value2: 1314,
				// title: "增长人数",
				data:[]
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {
			this.list()
		},
		computed: {

		},

		methods: {
			list() {
				this.loading = true
				this.$api.BIGrab.get().then((res) => {
					console.log(res)
					this.data = res
					this.loading = false
				})
				
				
			},
		},
		components: {

		}
	}
</script>
